import {alpha} from '@mui/material';
import ListItem from '@mui/material/ListItem';
import {useSidebarContext} from 'main/utility/AppContextProvider/SidebarContextProvider';
import PropsTypes from 'prop-types';
import {Fonts} from 'shared/constants/AppEnums';

const VerticalNavGroupItem = ({children, level, ...rest}) => {
  const {sidebarTextColor} = useSidebarContext();

  return (
    <ListItem
      sx={{
        height: 40,
        my: 0.25,
        pl: 31 + 12 * level + 'px',
        pr: 3,
        color: sidebarTextColor,
        fontWeight: Fonts.BOLD,
        fontSize: 14,
        cursor: 'pointer',
        textDecoration: 'none!important',
        whiteSpace: 'nowrap',
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        letterSpacing: '1.5px',
        textTransform: 'uppercase',
        '&.nav-item-header': {
          cursor: 'auto',
          mt: 3, // Adds a "Porsche" cockpit spacing between groups
          pt: 2,
          borderTop: `1px solid ${alpha(sidebarTextColor, 0.5)}`, // Very faint "etched" line
        },
      }}
      {...rest}
    >
      {children}
    </ListItem>
  );
};

export default VerticalNavGroupItem;

VerticalNavGroupItem.propTypes = {
  children: PropsTypes.node,
  level: PropsTypes.number,
};
